import * as React from "react";
import type { SVGProps } from "react";
const SvgBusLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#bus-left_svg__a)">
      <path d="M18.5 18.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1M4.5 18.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5m0-3a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1" />
      <path d="M23 17h-3a1 1 0 0 1 0-2h2V9a1 1 0 0 0-1-1H4a2 2 0 0 0-2 2v5h1a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1v-6a4 4 0 0 1 4-4h17a3 3 0 0 1 3 3v7a1 1 0 0 1-1 1" />
      <path d="M16 17H7a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2" />
      <path d="M12 16a1 1 0 0 1-1-1V7.5a1 1 0 0 1 2 0V15a1 1 0 0 1-1 1M8 16a1 1 0 0 1-1-1V7.67a1 1 0 0 1 2 0V15a1 1 0 0 1-1 1" />
      <path d="M3.59 13H1a1 1 0 0 1 0-2h2.59l.41-.41A2 2 0 0 1 5.41 10H23a1 1 0 0 1 0 2H5.41l-.41.41a2 2 0 0 1-1.41.59" />
    </g>
    <defs>
      <clipPath id="bus-left_svg__a">
        <path fill="#fff" d="M0 6h24v12.5H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBusLeft;
